var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnitsRemainingFlashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26044_69153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5498 1.92151C14.0396 0.461394 12.1895 -0.686699 11.1201 0.480331L2.85333 9.50139C2.00875 10.4231 2.65076 11.9283 3.91559 11.9283H7.89323C8.02839 11.9283 8.13586 12.0638 8.09071 12.2068L6.30369 17.869C5.84218 19.3314 7.69593 20.4462 8.74979 19.2764L16.9207 10.2061C17.7535 9.28159 17.1091 7.7883 15.8501 7.7883H11.8725C11.7359 7.7883 11.628 7.64991 11.6763 7.50605L13.5498 1.92151Z",
    fill: "white",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26044_69153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.7647,
    height: 19.7647,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitsRemainingFlashIcon);
export default __webpack_public_path__ + "static/media/units-remaining-flash-icon.d13ae2d0cb5b0b14d86032488e7a55fa.svg";
export { ForwardRef as ReactComponent };